<template>
  <MDBCardBody v-if="!loading">
    <MDBCardTitle v-html="formattedWelcomeMessage"></MDBCardTitle>
    <MDBCardText>
      <WelcomeBoxCompleteProfile :to="redirectLink" />
      <DashboardLink v-if="showProfileLink" class="text-uppercase" :to="{ name: redirectLink }">
        {{ $t("account.buttons.showProfile") }}
      </DashboardLink>
    </MDBCardText>
  </MDBCardBody>
</template>

<script setup>
import { MDBCardBody, MDBCardTitle, MDBCardText } from "mdb-vue-ui-kit";
import DashboardLink from "../Dashboard/Dashboard-link.vue";
import WelcomeBoxCompleteProfile from "./WelcomeBoxCompleteProfile.vue";
import { useStore } from "vuex";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { setLinkInWelcomeBox } from "@/composables/useProfileFieldCheck";

const store = useStore();
const { t } = useI18n();

const user = computed(() => store.getters.getMe);
const profile = computed(() => store.getters.getProfile);
const { tenantConfig } = useTenantConfig();
const { welcomeBoxLink, shouldShowProfileLink } = setLinkInWelcomeBox(tenantConfig);

const redirectLink = computed(() => welcomeBoxLink(user.value));
const showProfileLink = computed(() => shouldShowProfileLink(user.value));
const loading = ref(true);

watch([user, profile], ([userValue, profileValue]) => {
  if (userValue || profileValue) {
    loading.value = false;
  }
}, { immediate: true });

const formattedWelcomeMessage = computed(() => {
  if (profile.value && profile.value.forename && profile.value.name) {
    return t("dashboard.welcomeMessage", {
      first_name: profile.value.forename,
      last_name: profile.value.name
    });
  } else {
    return t("dashboard.welcomeMessage", {
      first_name: '',
      last_name: ''
    });
  }
});
</script>

<style scoped lang="scss">
@import "../../styles/_variables.scss";
@import "@/styles/welcome_box.scss";
@import "@/styles/mailbox.scss";

:deep(.card-title) {
  font-size: 20px;

  @media screen and (min-width: $xxlBreakpoint) {
    font-size: 25px;
  }
}

.message-notification {
  background: #f2790d;
  color: white;
  display: inline-block;
  border-radius: 25px;
  width: 18px;
  height: 18px;
  font-size: 12px;
  text-align: center;
  margin-left: 5px;
}

.title {
  position: relative;
}
</style>
